import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-900">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-[oklch(var(--primary-500))] flex items-center justify-center">
                <i className="ri-vidicon-line text-background-50 text-lg"></i>
              </div>
              <span
                className="text-xl font-bold text-background-50"
                style={{ fontFamily: 'var(--font-heading)' }}
              >
                香蕉视频
              </span>
            </div>
            <p className="text-foreground-500 text-sm leading-relaxed">
              短视频创作与分享平台，让每个有趣的灵魂都被看见。加入我们，开启你的创作之旅！
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-background-50 text-sm font-semibold mb-4">快速链接</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-foreground-500 text-sm hover:text-background-50 transition-colors">首页</Link>
              <Link to="/category/gaoxiao" className="text-foreground-500 text-sm hover:text-background-50 transition-colors">分类浏览</Link>
              <Link to="/about" className="text-foreground-500 text-sm hover:text-background-50 transition-colors">关于我们</Link>
            </div>
          </div>

          {/* Categories */}
          <div>
            <h4 className="text-background-50 text-sm font-semibold mb-4">热门分类</h4>
            <div className="flex flex-col gap-2">
              <Link to="/category/gaoxiao" className="text-foreground-500 text-sm hover:text-background-50 transition-colors">搞笑</Link>
              <Link to="/category/meishi" className="text-foreground-500 text-sm hover:text-background-50 transition-colors">美食</Link>
              <Link to="/category/yinyue" className="text-foreground-500 text-sm hover:text-background-50 transition-colors">音乐</Link>
              <Link to="/category/youxi" className="text-foreground-500 text-sm hover:text-background-50 transition-colors">游戏</Link>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-background-50 text-sm font-semibold mb-4">联系我们</h4>
            <div className="flex flex-col gap-3">
              <div className="flex items-center gap-2 text-foreground-500 text-sm">
                <i className="ri-mail-line text-base"></i>
                <span>support@bananavideo.cn</span>
              </div>
              <div className="flex items-center gap-2 text-foreground-500 text-sm">
                <i className="ri-phone-line text-base"></i>
                <span>400-888-8888</span>
              </div>
              <div className="flex items-center gap-2 text-foreground-500 text-sm">
                <i className="ri-map-pin-line text-base"></i>
                <span>北京市朝阳区香蕉大厦</span>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-foreground-700/30 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-500 text-xs">
            &copy; {currentYear} 香蕉视频 BananaVideo. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-foreground-500 text-xs hover:text-background-50 transition-colors">隐私政策</a>
            <a href="#" className="text-foreground-500 text-xs hover:text-background-50 transition-colors">服务条款</a>
            <a href="#" className="text-foreground-500 text-xs hover:text-background-50 transition-colors">社区规范</a>
          </div>
        </div>
      </div>
    </footer>
  );
}